/**
 * No Launcher Modal Component - Prompts user to download the Nitros Launcher
 */

import { Dialog } from './Dialog';
import { MonitorDownIcon } from 'lucide-preact';
import { DownloadButton } from './DownloadButton';

interface NoLauncherModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NoLauncherModal({ isOpen, onClose }: NoLauncherModalProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="No Launcher Detected">
      <div class="p-6 col gap-8 aic jcc h-full">
        <MonitorDownIcon class="w-48 h-48 text-neutral-800" />
        <p class="text-(neutral-400 center) leading-relaxed max-w-[36ch]">
          To launch apps from the store, make sure you have the Nitros Launcher installed on this device and that it is logged in to your account.
        </p>
        <DownloadButton />
      </div>
    </Dialog>
  );
}
